import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

function EventNotification() {
  const [nearestEvent, setNearestEvent] = useState(null);
  const [isVisible, setIsVisible] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    // Fetch nearest upcoming event
    const fetchNearestEvent = async () => {
      try {
        const response = await axios.get('/api/events/nearest');
        const event = response.data;
        setNearestEvent(event);
        
        // Check if this specific event was dismissed
        const dismissedEventId = localStorage.getItem('eventNotificationDismissed');
        if (dismissedEventId === event.id) {
          // This specific event was dismissed, don't show
          setIsDismissed(true);
          return;
        }
        
        // Show notification after a short delay
        setTimeout(() => {
          setIsVisible(true);
        }, 2000); // Show after 2 seconds
      } catch (error) {
        // No upcoming events or error - don't show notification
        if (error.response?.status !== 404) {
          console.error('Error fetching nearest event:', error);
        }
      }
    };

    fetchNearestEvent();
  }, []);

  const handleClick = () => {
    if (nearestEvent) {
      navigate(`/events/${nearestEvent.id}`);
      handleDismiss();
    }
  };

  const handleDismiss = () => {
    setIsVisible(false);
    setIsDismissed(true);
    // Remember dismissal for this specific event (by ID)
    if (nearestEvent) {
      localStorage.setItem('eventNotificationDismissed', nearestEvent.id);
    }
  };

  if (!nearestEvent || isDismissed) {
    return null;
  }

  const imageUrl = nearestEvent.image
    ? (nearestEvent.image.startsWith('/uploads/')
        ? nearestEvent.image
        : `/uploads/${nearestEvent.image}`)
    : '/img/Gallery/opd1.jpg';

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', { 
      month: 'short', 
      day: 'numeric',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  return (
    <div
      className={`event-notification ${isVisible ? 'visible' : ''}`}
      onClick={handleClick}
    >
      {/* Event Image */}
      <img
        src={imageUrl}
        alt={nearestEvent.title}
        onError={(e) => {
          e.target.src = '/img/Gallery/opd1.jpg';
        }}
      />
      
      {/* Notification Badge */}
      <div className="event-notification-badge">
        <i className="bi bi-calendar-event"></i>
      </div>

      {/* Tooltip on hover */}
      <div className="event-notification-tooltip">
        <button
          className="event-notification-close"
          onClick={(e) => {
            e.stopPropagation();
            handleDismiss();
          }}
          aria-label="Close notification"
        >
          <i className="bi bi-x"></i>
        </button>
        <div className="event-notification-title">
          {nearestEvent.title}
        </div>
        <div className="event-notification-date">
          <i className="bi bi-calendar3 me-1"></i>
          {formatDate(nearestEvent.event_date)}
        </div>
        {nearestEvent.location && (
          <div className="event-notification-location">
            <i className="bi bi-geo-alt me-1"></i>
            {nearestEvent.location}
          </div>
        )}
        <div className="event-notification-hint">
          Click to view details
        </div>
      </div>
    </div>
  );
}

export default EventNotification;
